import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { AbstractDetailsComponent } from '../../../../shared/abstracts/details/abstract-details/abstract-details.component';
import { IAuditEvent } from '@ahryman40k/ts-fhir-types/lib/R4';
import { TranslatePipe } from '../../../../shared/translate/pipes/translate.pipe';
import { DetailsChangesView } from '../../../models/details.changes.model';
import { stringToDetailChanges } from '../../../functions/details.changes.function';

const OPERATION_NAMES = {
  Count: 'COUNT',
  Avg: 'AVERAGE',
  Std: 'SCATTER',
};

const COLS = [
  { name: 'NAME_COMMENT', colSize: 3 },
  { name: 'CHANGED_VALUE', colSize: 4.5 },
  { name: 'CHANGE', colSize: 4.5 }
];

@Component({
  selector: 'inc-details-changes',
  templateUrl: './details-changes.component.html',
  styleUrls: ['./details-changes.component.scss'],
})
export class DetailsChangesComponent extends AbstractDetailsComponent<IAuditEvent[]> implements OnInit {
  cols = COLS;

  detailsChangesViews: DetailsChangesView[];

  constructor(private translatePipe: TranslatePipe) {
    super();
  }

  ngOnInit() {
    this.setDetailsChanges();
  }

  setDetailsChanges() {
    this.detailsChangesViews = stringToDetailChanges(this.inData, this.translatePipe);
  }
}
